import { useCallback, useEffect, useState } from "react";
import client from "../client";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import handleApiError from "../../hooks/handleApiError";
import { setTotalUnreadNotifications } from "../../../redux/slices/notification/slice";

export default function useFetchNotifications(page) {
  const { teacherId } = useParams();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [pagination, setPagination] = useState(null);

  const request = useCallback(
    async (_page = 1) => {
      try {
        setLoading(true);

        const res = await client.get(
          `/notification?recipient=${teacherId}&page=${_page}`
        );
        setData(res.data?.data);
        setPagination(res.data?.pagination);

        const unreadNotifications = res.data?.data?.filter(
          (el) => !el?.isRead
        )?.length;
        dispatch(setTotalUnreadNotifications(unreadNotifications));

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [dispatch, teacherId]
  );

  useEffect(() => {
    if (page && teacherId) request(page);
  }, [request, page, teacherId]);

  return { data, pagination, loading };
}
